import { takeLatest, put } from 'redux-saga/effects';
import api from '../../../utils/apiConfig';
import WorkflowActionTypes from './types';
import {
  fetchCollectionEnumsSuccess,
  fetchScheduledMapDataSuccess,
  fetchCollectionDataSuccess,
  fetchScheduledVehiclesSuccess,
  fetchScheduledCountSuccess,
  fetchScheduledItenarySuccess,
  fetchPathDetailSuccess,
  validateActionTimeSuccess,
  updateConsignmentSuccess,
  fetchFiltersSuccess,
  fetchDocketDataSuccess,
  deleteTripSuccess,
  saveCollectionSuccess,
  saveDocketSuccess,
  deleteDocketSuccess,
  deleteInvoiceSuccess,
  findConsigneeSuccess,
  getCurrentLocationSuccess,
} from './actions';
import UrlConfig from './urls';
import { ResponseGenerator } from '../../../utils/globalContracts';

function* getCollectionEnums(action: any) {
  const requestURL = UrlConfig.fetchCollectionEnums();
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchCollectionEnumsSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchDocketData(action: any) {
  const requestURL = UrlConfig.fetchDocketData(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchDocketDataSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* fetchFilters(action: any) {
  const requestURL = UrlConfig.fetchFilters();
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchFiltersSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getScheduledMapData(action: any) {
  const requestURL = UrlConfig.fetchScheduledMapData(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchScheduledMapDataSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* deleteDocket(action: any) {
  const requestURL = UrlConfig.deleteDocket(action.payload);
  try {
    const response: ResponseGenerator = yield api.delete(requestURL);
    yield put(deleteDocketSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* deleteInvoice(action: any) {
  const requestURL = UrlConfig.deleteInvoice(action.payload);
  try {
    const response: ResponseGenerator = yield api.delete(requestURL);
    yield put(deleteInvoiceSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* saveCollection(action: any) {
  const requestURL = UrlConfig.saveCollection();
  try {
    const response: ResponseGenerator = yield api.post(requestURL, action.payload);
    yield put(saveCollectionSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* saveDocket(action: any) {
  const requestURL = UrlConfig.saveDocket();
  try {
    const response: ResponseGenerator = yield api.post(requestURL, action.payload);
    console.log({ response });
    yield put(saveDocketSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* deleteTrip(action: any) {
  const requestURL = UrlConfig.deleteTrip(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(deleteTripSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getCollectionData(action: any) {
  const requestURL = UrlConfig.fetchCollectionData(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchCollectionDataSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* findConsignee(action: any) {
  const requestURL = UrlConfig.findConsignee(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(findConsigneeSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getScheduledVehiclesData(action: any) {
  const requestURL = UrlConfig.fetchScheduledVehicles(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchScheduledVehiclesSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getCurrentLocation(action: any) {
  const requestURL = UrlConfig.getCurrentLocation(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(getCurrentLocationSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getPathDetail(action: any) {
  const requestURL = UrlConfig.fetchPathDetail(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchPathDetailSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* validateActionTime(action: any) {
  const requestURL = UrlConfig.validateActionTime(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(validateActionTimeSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* updateConsignment(action: any) {
  const requestURL = UrlConfig.updateConsignment();
  try {
    const response: ResponseGenerator = yield api.post(requestURL, action.payload);
    yield put(updateConsignmentSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getScheduledItenaryData(action: any) {
  const requestURL = UrlConfig.fetchScheduledItenary(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchScheduledItenarySuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* getScheduledCount(action: any) {
  const requestURL = UrlConfig.fetchScheduledCount(action.payload);
  try {
    const response: ResponseGenerator = yield api.get(requestURL);
    yield put(fetchScheduledCountSuccess(response.data.data));
  } catch (e) {
    console.log({ e });
  }
}

function* workflowSaga() {
  yield takeLatest(WorkflowActionTypes.FETCH_DOCKET_DATA_START, fetchDocketData);
  yield takeLatest(WorkflowActionTypes.FETCH_COLLECTION_ENUMS, getCollectionEnums);
  yield takeLatest(WorkflowActionTypes.FETCH_SCHEDULED_MAP, getScheduledMapData);
  yield takeLatest(WorkflowActionTypes.FETCH_COLLECTION_DATA_START, getCollectionData);
  yield takeLatest(WorkflowActionTypes.FIND_CONSIGNEE, findConsignee);
  yield takeLatest(WorkflowActionTypes.FETCH_SCHEDULED_VEHICLES_START, getScheduledVehiclesData);
  yield takeLatest(WorkflowActionTypes.FETCH_SCHEDULED_ITENARY_START, getScheduledItenaryData);
  yield takeLatest(WorkflowActionTypes.FETCH_SCHEDULED_COUNT_START, getScheduledCount);
  yield takeLatest(WorkflowActionTypes.FETCH_PATH_DETAIL_START, getPathDetail);
  yield takeLatest(WorkflowActionTypes.VALIDATE_ACTION_TIME, validateActionTime);
  yield takeLatest(WorkflowActionTypes.UPDATE_CONSIGNMENT, updateConsignment);
  yield takeLatest(WorkflowActionTypes.FETCH_FILTERS_START, fetchFilters);
  yield takeLatest(WorkflowActionTypes.DELETE_TRIP_START, deleteTrip);
  yield takeLatest(WorkflowActionTypes.SAVE_COLLECTION_START, saveCollection);
  yield takeLatest(WorkflowActionTypes.SAVE_DOCKET_START, saveDocket);
  yield takeLatest(WorkflowActionTypes.DELETE_DOCKET_START, deleteDocket);
  yield takeLatest(WorkflowActionTypes.DELETE_INVOICE_START, deleteInvoice);
  yield takeLatest(WorkflowActionTypes.GET_CURRENT_LOCATION_START, getCurrentLocation);
}
export default workflowSaga;
